import { useIsMobile } from '@sravni/react-utils';

import { useAppSelector } from 'shared/lib';

import { selectMobileApp } from 'features/MobileApp/model/mobileApp.selector';

import type { TMobileAppViewProps } from '../types/MobileApp.types';

import { MobileAppDesktop } from './MobileAppDesktop';
import { MobileAppMobile } from './MobileAppMobile';

export const MobileApp = ({ title, subtitle, color, desktopTextBlockClassName }: TMobileAppViewProps) => {
  const content = useAppSelector(selectMobileApp);
  const isMobile = useIsMobile();

  const viewProps: TMobileAppViewProps = {
    title: title || content?.title,
    subtitle: subtitle || content?.subtitle,
    color,
    desktopTextBlockClassName,
  };

  if (!viewProps?.title || !viewProps?.subtitle) {
    return null;
  }

  const Component = isMobile ? MobileAppMobile : MobileAppDesktop;

  return <Component {...viewProps} />;
};
